export default "__VITE_ASSET__a286f265__"